var _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 54.5,
    stroke: "#E83A2A",
    strokeOpacity: 0.6,
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 80.5,
    fill: "#E83A2A",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 50.5,
    fill: "#E83A2A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 45.5,
    stroke: "#E83A2A",
    strokeOpacity: 0.1,
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9998 93.9998C74.4878 93.9998 73.9757 93.8048 73.5857 93.4138C72.8047 92.6328 72.8047 91.3668 73.5857 90.5858L97.5858 66.5857C98.3668 65.8047 99.6328 65.8047 100.414 66.5857C101.195 67.3668 101.195 68.6328 100.414 69.4138L76.4138 93.4138C76.0238 93.8048 75.5118 93.9998 74.9998 93.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9997 94.0008C74.4877 94.0008 73.9767 93.8058 73.5857 93.4148L61.5857 81.4148C60.8047 80.6338 60.8047 79.3668 61.5857 78.5857C62.3657 77.8047 63.6328 77.8047 64.4138 78.5857L76.4138 90.5857C77.1947 91.3667 77.1947 92.6327 76.4138 93.4137C76.0238 93.8057 75.5117 94.0008 74.9997 94.0008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.0d4007f0ab55e32b6f70601fd1da53a4.svg";
export { ForwardRef as ReactComponent };